import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AboutPage from './AboutPage';
import AppFrame from './AppFrame';
import Home from './HomePage';
import MaterialBrowser from './MaterialBrowser';
import SupportPage from './SupportPage';
import Stackup from './StackupDesign';
import Config from './Config';
import Refresh from './Refresh';

// When adding a route, make sure to add an entry to ../lib/nav-paths.js
const App = () => (
  <AppFrame>
    <Switch>
      <Route exact path="/" component={Home} />
      <Route path="/app" component={Stackup} />
      <Route path="/material-browser" component={MaterialBrowser} />
      <Route path="/about" component={AboutPage} />
      <Route path="/support" component={SupportPage} />
      <Route path="/config" component={Config} />
      <Route path="/refresh" exact component={Refresh} />
    </Switch>
  </AppFrame>
);

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js